import React, { useState, useEffect } from "react";
import "./ImageCarousel.scss";
import arrow from "../../assets/arrow-black.svg";
import { bannerClick, bannerImpression } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useHistory } from "react-router";
import config from "react-global-configuration";

const ImageCarousel = ({ content }) => {

    const [currentIndex, setCurrentIndex] = useState(0);
    const history = useHistory()
    const goToPrev = () => {
        setCurrentIndex((prev) => (prev === 0 ? content.length - 1 : prev - 1));
    };

    const goToNext = () => {
        setCurrentIndex((prev) => (prev === content.length - 1 ? 0 : prev + 1));
    };

    const goToIndex = (index) => {
        setCurrentIndex(index);
    };

    useEffect(() => {
        if (content.length > 1) {
            const timer = setInterval(() => {
                goToNext();
            }, 5000);

            return () => clearInterval(timer);
        }
    }, [currentIndex]);
    return (
        <div className="custom-carousel">
            <div
                className="custom-carousel-track"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
                {content.map((contnt, i) => (
                    <div className={"custom-carousel-slide"} key={i}>
                        {config.get('Theme') !== 'Hospitality-Default-V3-REGAL' && (
                            <div
                                className="custom-carousel-slide-overlayer"
                            />
                        )}
                        <img src={contnt.imageUrl} alt={`Slide ${i}`} />
                        <div className="carousel-caption-container">
                            <div className="carpousel-eahder-text">{contnt.title}</div>
                            <div className="carpousel-sub-text">
                                {contnt.subtitle}
                            </div>
                            {contnt.buttonText && contnt.buttonText !== "" && <div className="carousel-btn"
                                onClick={async () => {
                                    await bannerClick(contnt.id)
                                    await bannerImpression(contnt.id)
                                    history.push(contnt.linkUrl)
                                }}>{contnt.buttonText}</div>}
                        </div>
                    </div>
                ))}
            </div>

            {content.length > 1 && <div className="custom-carousel-button left" onClick={goToPrev}>
                <img alt="" src={arrow} />
            </div>}
            {content.length > 1 && <div className="custom-carousel-button right" onClick={goToNext}>
                <img alt="" src={arrow} />
            </div>}

            {content.length > 1 && <div className="custom-carousel-dots">
                {content.map((_, i) => (
                    <div
                        key={i}
                        onClick={() => goToIndex(i)}
                        className={`dot-cs ${i === currentIndex ? "active" : ""}`}
                    />
                ))}
            </div>}
        </div>
    );
};

export default ImageCarousel;
